import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { MdfOverviewCard } from '../../../mdfOverviewCard'

import styles from './ActivityOutcomesCard.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.activityOutcomes

interface IActivityOutcomesCardProps {
  executedCount: number
  outcomeProvidedCount: number
  onProvideOutcomeClick: () => void
}

export const ActivityOutcomesCard = ({
  executedCount,
  outcomeProvidedCount,
  onProvideOutcomeClick,
}: IActivityOutcomesCardProps) => {
  const needOutcomeCount = executedCount - outcomeProvidedCount

  return (
    <MdfOverviewCard
      title={KEYS.title}
      value={`${outcomeProvidedCount} / ${executedCount}`}
      footer={
        <div className={styles.footer}>
          {needOutcomeCount > 0 ? (
            <Button
              className={styles.provideOutcomeLink}
              variant="text"
              color="danger"
              size="sm"
              onClick={onProvideOutcomeClick}
            >
              <Translation
                text={KEYS.footerTitle}
                replaceParams={[{ key: '{count}', value: String(needOutcomeCount) }]}
              />
            </Button>
          ) : (
            <Translation text={KEYS.footerDescription} />
          )}
        </div>
      }
    />
  )
}

ActivityOutcomesCard.displayName = 'ActivityOutcomesCard'
